import React from 'react';
import SwaggerUI from 'swagger-ui-react';
import "swagger-ui-react/swagger-ui.css"

interface ServicePageProps {
    service: string;
}

const ServicePage: React.FC<ServicePageProps> = ({service}) => {
    return (
        <SwaggerUI
            url={`/upstream/${service}/documentation`}
            docExpansion="list"
        />
    );
}

export default ServicePage;
